import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAccessToken, useUserRoles, useRefreshToken } from '@services/token/token.hooks'
import AppLayout from './AppLayout'
import Protocols from './Protocols'
import DashboardLayout from './DashboardLayout'
import SelectProtocol from './SelectProtocol'
import Login from './Login'
import AuthCallback from './AuthCallback'
import { Box, CircularProgress } from '@mui/material'
import Helpdesk from './helpdesk/Helpdesk'
import HelpdeskTickets from './helpdesk/HelpdeskTickets'
import HelpdeskTicketDetails from './helpdesk/HelpdeskTicketDetails'
import ClientManagement from './ClientManagement'

function Router() {
  const { accessToken, hasLocalStorageTokens } = useAccessToken()
  const { isTechnician } = useUserRoles()
  useRefreshToken() // Enable proactive token refresh every 25 minutes

  if (hasLocalStorageTokens && !accessToken) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          minWidth: '100vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  if (!accessToken) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<AppLayout />}>
            <Route index element={<Login />} />
            <Route path='auth'>
              <Route index element={<Login />} />
              <Route path='callback' element={<AuthCallback />} />
            </Route>
            <Route path='*' element={<Navigate to='/' replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    )
  }

  // Routing for technicians (access only to Helpdesk)
  if (isTechnician()) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<DashboardLayout />}>
            {/* Redirect from main page to helpdesk */}
            <Route index element={<Navigate to='/helpdesk/tickets' replace />} />

            {/* Paths for helpdesk */}
            <Route path='helpdesk' element={<Helpdesk />}>
              <Route index element={<Navigate to='tickets' replace />} />
              <Route path='tickets' element={<HelpdeskTickets />} />
              <Route path='tickets/:id' element={<HelpdeskTicketDetails />} />
            </Route>

            {/* Redirect all other paths to helpdesk */}
            <Route path='*' element={<Navigate to='/helpdesk/tickets' replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    )
  }

  // Routing for regular users (access to protocols and client management)
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<DashboardLayout />}>
          <Route index element={<SelectProtocol />} />
          <Route path=':id' element={<Protocols />} />
          <Route path='clients' element={<ClientManagement />} />
          <Route path='clients/:id/edit' element={<ClientManagement />} />

          {/* Redirect all other paths to protocols */}
          <Route path='*' element={<Navigate to='/' replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default Router
